import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName:"Footer" */ './Footer').then((mod) => mod.default));
